/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import get from 'lodash/get';
import { compose } from 'lodash/fp';
import { withNamespaces } from 'react-i18next';
import querystring from 'querystring';
import { Column, MediaQueries } from '../../../../../styles/Grid';
import { SafePureComponent } from '../../../../../utils/SafePureComponent';
import { RICH_FILTERING as dict } from '../../../../../utils/dictionarykeys';
import {
  SORT_BY_QUERY_PARAM,
  SORT_BY_LOW_TO_HIGH,
} from '../../../../../utils/constants';
import { withConsumer } from '../../../../../contexts';
import { RichFilteringConsumer } from '../../../../../contexts/RichFilteringContext';
import { showElementCss } from '../../../../../utils/responsive';
import createButtonCss from '../../../../ui/Button/Button';
import FiltersModal from '../FiltersModal';
import { getDecodedQueryParams } from '../../../../../utils/url';
import * as styles from './index.styles';

export class FilterButtons extends SafePureComponent {
  state = {
    numberOfSelectedFilters: false,
  };

  clearModalState = () => {};

  filterIcon = () => (
    <span css={styles.iconFilter} className="icon-filters"></span>
  );

  selectedFilters = numberOfSelectedFilters => {
    this.setState({ numberOfSelectedFilters });
  };

  onChangeSort = (_event, _selectedLabel, index) => {
    const sortItems = get(this.props.fields, 'Filters.Sorting.items', []);
    const params = getDecodedQueryParams();
    params[SORT_BY_QUERY_PARAM] = sortItems[index].value;
    const encodedParams = `?${querystring.encode(params)}`;
    window.location.search = encodedParams;
  };

  onClickClear = () => {
    const { replaceWindowUrl, filterLocations } = get(
      this.props,
      'richFilteringContext.actions',
      {},
    );
    const queryParams = {
      brands: [],
      sort: SORT_BY_LOW_TO_HIGH,
      min: '',
      max: '',
    };

    replaceWindowUrl(queryParams);
    filterLocations(queryParams);
    this.selectedFilters(false);
    this.clearModalState();
  };

  safeRender() {
    const { numberOfSelectedFilters } = this.state;
    const { openModal, closeModal } = get(
      this.props,
      'richFilteringContext.actions',
      {},
    );
    const { isFilterModalOpen } = get(
      this.props,
      'richFilteringContext.state',
      {},
    );
    const { fields, t } = this.props;
    const { Filters } = fields;
    const isAFilterActive = numberOfSelectedFilters > 0;

    return (
      <React.Fragment>
        <Column
          cols={{
            sm: 6,
            md: 3,
            lg: isAFilterActive ? 3 : 4,
            xl: isAFilterActive ? 2 : 3,
          }}
          css={styles.filterColumn}
        >
          <button
            onClick={openModal}
            css={[createButtonCss('secondary'), styles.filter]}
          >
            <span css={styles.filterText(isAFilterActive)}>
              {t(dict.FILTERS_AND_SORT)}
            </span>
            {this.filterIcon()}
          </button>
        </Column>
        {isAFilterActive && (
          <Column
            css={showElementCss(MediaQueries.lgAndUp)}
            cols={{ lg: 1, xl: 1 }}
          >
            <button onClick={this.onClickClear} css={styles.clearButton}>
              <span css={styles.clearText}>{t(dict.CLEAR)}</span>
            </button>
          </Column>
        )}
        <FiltersModal
          closeModal={closeModal}
          isModalOpen={isFilterModalOpen}
          filters={Filters}
          selectedFilters={this.selectedFilters}
          clearModalState={clearModalState =>
            (this.clearModalState = clearModalState)
          }
          t={t}
        />
      </React.Fragment>
    );
  }
}

FilterButtons.defaultProps = {
  t: key => `dict-${key}`,
};

export default compose(
  withNamespaces(),
  withConsumer(RichFilteringConsumer, 'richFilteringContext'),
)(FilterButtons);
